import React, { memo } from 'react'
import { string } from 'prop-types'

import classNames from 'src/common/helpers/class-names'

const blk = 'co-product'

const Volume = memo(({ className, value }) => (
  <span className={classNames({ className, blk, elt: 'volume' })}>{value}</span>
))

Volume.propTypes = { className: string, value: string }
Volume.defaultProps = { className: '', value: '' }

export default Volume



// WEBPACK FOOTER //
// ./shared/interim/product/volume/index.js